import { z } from 'zod'

/** {@link https://solana.com/docs/rpc/json-structures#token-balances} */
export const tokenBalanceSchema = z.object({
  /** Index of the account in which the token balance is provided for. */
  accountIndex: z.number(),
  /** Pubkey of the token's mint. */
  mint: z.string(),
  /** Pubkey of token balance's owner. */
  owner: z.string().optional(),
  /** Pubkey of the Token program that owns the account. */
  programId: z.string().optional(),
  uiTokenAmount: z.object({
    /** Raw amount of tokens as a string, ignoring decimals. */
    amount: z.string(),
    /** Number of decimals configured for token's mint. */
    decimals: z.number(),
    /** Token amount as a string, accounting for decimals. */
    uiAmountString: z.string(),
  }),
})
